/* Fermeture du bandeau de decouverte de la page collection.
   Sorti du <script> inline de la section (non mis en cache, non minifie). */
(() => {
  const init = (root) => {
    if (root.dataset.mmCollectionPret === '1') return;
    root.dataset.mmCollectionPret = '1';

    const notice = root.querySelector('[data-mm-discovery-notice]');
    const bouton = notice && notice.querySelector('[data-mm-discovery-close]');
    if (!bouton) return;
    bouton.addEventListener('click', () => {
      notice.hidden = true;
    });
  };

  const boot = (scope) => scope.querySelectorAll('[data-mm-collection]').forEach(init);
  boot(document);
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
